<template>
  <div class="relative">
    <div class="md:flex md:gap-4">
      <div class="md:basis-1/2">
        <div class="relative">
          <BaseFormInput
            v-model="batteryPackModel.serialNumber"
            label="Seriennummer der Batterieeinheit"
            :validation="validation ? validation.serialNumber : undefined"
            type="text"
            test-id="serialNumberBatteryPack"
            class="z-10"
            :disabled="isDisabled"
            :warning="isBatteryPackNumberDuplicated"
            :warning-message="i18n.warning.duplicatedSerialNumber"
          >
            <template #trailing>
              <span
                class="mdi mdi-qrcode-scan text-3xl"
                @click="openDeviceCodeScanner"
              />
            </template>
          </BaseFormInput>
        </div>
      </div>
      <div class="md:basis-1/2">
        <BaseFormInput
          v-model="batteryPackModel.customizedNumber"
          :validation="validation ? validation.customizedNumber : undefined"
          label="Artikelnummer der Batterieeinheit"
          type="number"
          :disabled="isDisabled"
          test-id="customizedNumberBatteryPack"
        />
      </div>
    </div>
  </div>
  <div v-if="isCodeScanActive">
    <DeviceCodeScanner
      :device-type="AccessoryType.SRT_BATTERY_PACK"
      @scan-result="scanResult($event)"
    />
  </div>
</template>
<script setup lang="ts">
import BaseFormInput from '@/components/UI/Input/BaseFormInput.vue';
import { computed, ref } from 'vue';
import DeviceCodeScanner from '@/components/UI/Scanner/DeviceCodeScanner.vue';
import { AccessoryType } from '@/enums/device';
import { Validation } from '@vuelidate/core';
import { BatteryPackScanResult } from '@/models/scanner/ScanResult';
import { unknownPropertiesHelper } from '@/utils/scanner/unknownPropertiesHelper';
import { BatteryPack } from '@/models/installationPoint/Accessory';
import { useInstallationPointStore } from '@/store/entities/installationPointStore';
import i18n from '@/utils/i18n/form.json';
import useHardwareScanListener from '@/components/UI/Scanner/useHardwareScanListener';

const batteryPackModel = defineModel<BatteryPack>({ required: true });

const props = defineProps<{
  validation?: Validation;
  isDisabled?: boolean;
}>();

const isCodeScanActive = ref(false);
const openDeviceCodeScanner = () => {
  return (isCodeScanActive.value = true);
};

const scanResult = (batteryPackScanResult: BatteryPackScanResult | object) => {
  if (batteryPackScanResult instanceof BatteryPackScanResult) {
    if (batteryPackScanResult.serialNumberBatteryPack) {
      batteryPackModel.value.serialNumber =
        batteryPackScanResult.serialNumberBatteryPack;
    }
    if (batteryPackScanResult.customizedNumberBatteryPack) {
      batteryPackModel.value.customizedNumber =
        batteryPackScanResult.customizedNumberBatteryPack;
    }
    if (batteryPackScanResult.productKey) {
      batteryPackModel.value.productKey = batteryPackScanResult.productKey;
    }
    if (batteryPackScanResult.unknownProperties) {
      const currentUnknownProperties = batteryPackModel.value.unknownProperties;
      batteryPackModel.value.unknownProperties = unknownPropertiesHelper(
        currentUnknownProperties,
        batteryPackScanResult.unknownProperties
      );
    }
  }
  isCodeScanActive.value = false;
};

const isBatteryPackNumberDuplicated = computed(() => {
  return !useInstallationPointStore().isUniqueBatteryPack(
    batteryPackModel.value
  );
});

useHardwareScanListener(scanResult, AccessoryType.SRT_BATTERY_PACK);
</script>
